import Modal from '@components/v2/ui/Modal/Modal';
import { MODAL_BODY_PADDING } from '@components/v2/ui/Modal/modal.constants';
import { Box } from '@mui/material';
import { Sparkles } from 'lucide-react';
import { HighlightOutput } from '../../services/modules/highlights/highlights.types';
import { HighlightsTestIds } from '../../utils/testIds/Highlights.testIds';
import HighlightDetails from './HighlightDetails';

const CONTENT_STYLES = {
  px: { xs: 0, sm: 4 - MODAL_BODY_PADDING },
  pt: { xs: 0, sm: 2 },
  pb: { xs: 0, sm: 4 - MODAL_BODY_PADDING },
} as const;

interface HighlightModalProps {
  isOpen: boolean;
  highlight: HighlightOutput | null;
  onClose: () => void;
}

const HighlightModal = ({ isOpen, highlight, onClose }: HighlightModalProps) => {
  if (!highlight) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      size="expanded"
      testId={HighlightsTestIds.MODAL}
      header={{ title: highlight.title, icon: Sparkles }}
      onClose={onClose}
    >
      <Box sx={CONTENT_STYLES}>
        <HighlightDetails
          title={highlight.title}
          publishedAt={highlight.publishedAt}
          text={highlight.text}
          media={highlight.media}
        />
      </Box>
    </Modal>
  );
};

export default HighlightModal;
